module.exports = __webpack_public_path__ + "img/logo.727170a4.png";